<div class="mobile-tabs" [ngClass]="{'open': isOpen}">
  <ul #unorderedList>
    <li>
      <a class="text" (click)="onToggle()">{{selectedText}}</a>
      <ng-content></ng-content>
    </li>
  </ul>
</div>
